import React, { useContext } from 'react'

import { Alert, Box, Button, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';

import { PageNames, PageContext } from '../Home/HomeTopMailConfirm';
import { HeldTimesContext } from '../Root/CompetitionRoot';

/**
 * 応募画面トップページ
 * メール登録、登録内容確認を行う
 */
export function KaguTop() {

    const [t] = useTranslation();

    const {setPage} = useContext(PageContext);

    const heldTimesOption = useContext(HeldTimesContext);

    return(
        <>
            <Box>
                <Typography 
                    variant='h4'
                    sx={{
                        textAlign:"left",
                        mt:1
                    }}
                >
                    {t("KaguTop.Title1", heldTimesOption)}<br/>
                    {t("KaguTop.Title2")}{" "}{t("KaguTop.Title3")}
                </Typography>   
                <Alert icon={false} severity="info"
                    sx={{
                        mt:1,
                        textAlign:"left"
                    }}
                >
                    {t("KaguTop.Text1", heldTimesOption)}<br/>
                    {t("KaguTop.Text2")}
                </Alert>
                <Box sx={{mt:1}}>
                    <Grid2 container spacing={1}>
                        <Grid2>
                            <Button variant="contained" onClick={() => setPage(PageNames.KaguMailForm)}>{t("KaguTop.Register")}</Button>
                        </Grid2>
                        <Grid2>
                            <Button variant="outlined" onClick={() => setPage(PageNames.KaguRefForm)}>{t("KaguTop.Confirm")}</Button>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>     
        </>
    );
}